<app-landing-toolbar></app-landing-toolbar>
<div id="request-reset-wrapper" class="primary-background-gradient">
    <mat-card *ngIf="!done">
        <h1>Request Password Reset</h1>
        <form (ngSubmit)="onSubmit()" [formGroup]="requestResetForm">
            <mat-form-field class="full-width">
                <input formControlName="email" matInput placeholder="Email" type="email">
                <mat-error *ngIf="requestResetForm.controls.email.hasError('required')">You need to provide an email to
                    reset your password!
                </mat-error>
            </mat-form-field>
            <div id="login-button">
                <button [disabled]="!requestResetForm.valid || needsVerify" class="full-width" color="primary" mat-raised-button gtagEvent trackOn="click" action="reset_requested" category="accounts">
                    Reset Password
                </button>
            </div>
            <mat-error *ngFor="let error of errors">{{error}}</mat-error>
            <button *ngIf="needsVerify" [disabled]="!requestResetForm.valid" class="full-width" color="primary" mat-raised-button gtagEvent trackOn="click" action="resend_verify" category="accounts" (click)="resendVerify()">
                Resend Verification Email
            </button>
        </form>
    </mat-card>
    <mat-card *ngIf="done">
        <h2>Please check your email for your {{needsVerify ? 'verification' : 'reset'}} link!</h2>
        <a routerLink="/home">Login</a>
    </mat-card>
</div>